import { KeycloakProvider } from '@elotech/components';
import { CidadeOperations } from 'itbi-common/state/cidade';
import { ConfigOperations } from 'itbi-common/state/config';
import { UserOperations } from 'itbi-common/state/user';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

class AppKeycloakProvider extends React.Component {
  static propTypes = {
    isKeycloakLoaded: PropTypes.bool,
    setKeycloakLoaded: PropTypes.func,
    checkUserExists: PropTypes.func,
    getUserData: PropTypes.func,
    keycloakService: PropTypes.object,
    loadUserProfile: PropTypes.func,
    idpHint: PropTypes.string
  };

  render() {
    const {
      keycloakService,
      setKeycloakLoaded,
      checkUserExists,
      isKeycloakLoaded,
      getUserData,
      loadUserProfile,
      children,
      getCidadeLogada,
      idpHint
    } = this.props;
    return (
      <KeycloakProvider
        keycloakService={keycloakService}
        checkUserExists={checkUserExists}
        getUserData={getUserData}
        isKeycloakLoaded={isKeycloakLoaded}
        loadUserProfile={loadUserProfile}
        setKeycloakLoaded={setKeycloakLoaded}
        idpHint={idpHint}
        getCidadeLogada={getCidadeLogada}
      >
        {children}
      </KeycloakProvider>
    );
  }
}

const mapStateToProps = state => ({
  isKeycloakLoaded: state.config.keycloakLoaded
});

export default connect(mapStateToProps, {
  setKeycloakLoaded: ConfigOperations.setKeycloakLoaded,
  checkUserExists: UserOperations.checkUserExists,
  getUserData: () => UserOperations.getUserData(true),
  loadUserProfile: UserOperations.loadUserProfile,
  getCidadeLogada: CidadeOperations.getCidadeLogada
})(withRouter(AppKeycloakProvider));
